import React, {Component} from 'react';
import '../../style/tooltip.css'
import infoIcon from '../../info.svg';
class Tooltip extends Component {
    constructor(props) {
        super(props);
        this.state = {displayTooltip: false};
    }

    _openTooltip = () => {
        this.setState({
            displayTooltip: true
        })
    };

    _closeTooltip = () => {
        this.setState({
            displayTooltip: false
        })
    };

    render(){
        return (
            <div className="custom-tooltip__wrapper">
                <img
                    className="custom-tooltip__info-icon inlineBlock"
                    src={infoIcon}
                    onMouseOver={() => this._openTooltip()}
                    onMouseLeave={() =>  this._closeTooltip()}/>
                {
                    this.state.displayTooltip?
                        <div className="custom-tooltip__box ">
                            <div className="">
                                {this.props.text}
                            </div>
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

export default Tooltip;